import {SUIT} from '@constant/game';
import {PlayerComponent, PokerComponent} from '@interface';
import {GameLogicInterface} from 'poker-interfaces';
import {cloneDeep} from 'lodash-es';
import {GameType} from 'poker-interfaces/gameLogic/gameLogicInterface';

const getMockPlayer = ({
  index,
  gameType,
  hasResult,
}: {
  index: number;
  gameType: GameType;
  hasResult: boolean;
}) => {
  const handLength = gameType === 'OMAHA' ? 4 : 2;
  return {
    id: index,
    icon: null,
    username: 'ben',
    socketId: index.toString(),
    role: index !== 7 ? 'BUTTON' : null,
    order: index,
    gameMode: gameType,
    roomCode: null,
    outCards: Array(12)
      .fill(null)
      .map(() => ({suit: 'SPADE', rank: 10})) as GameLogicInterface.CardObj[],

    remainingMoney: 100,
    hand: hasResult
      ? Array(handLength)
          .fill(null)
          .map((_v, index) => {
            return {
              suit: 'HEART',
              rank: 8 + index,
            };
          })
      : null,
    handLength,
    isFolded: false,
    isActive: true,
    isDisconnected: false,
    isSatOut: false,
    isSitOutNextHand: false,
    currentDecision: 'BET', // bet call, including small and big blind
    currentBet: 102,
    availableActions: ['BET', 'CHECK', 'FOLD'],
    isAllIn: false,
    isAllInMode: false,
    // useImperative methods

    actionTime: 10,
    isResultShowing: hasResult,
    isTimerHidden: false,
    disconnectedAt: null,
    forceKickAt: null,

    isWaitingForBlinds: false,
    needWaitForBlinds: false,
  };
};

export const mockTableInfo = {
  roomCode: 'YPHA',
  gameId: 4579396,
  currentPot: 0,
  players: [
    {
      id: 0,
      username: 'Chrono534',
      socketId: '3vUTnTPkV-vGv8eTAATa',
      currentDecision: null,
      currentBet: 10,
      hand: [
        {suit: 'HEART', rank: 5},
        {suit: 'HEART', rank: 9},
      ],
      handLength: 2,
      order: 2,
      role: null,
      isFolded: false,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/278edca4-2e27-46e4-8f68-cd96d4f202d5.png',
      remainingMoney: 4.21,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 1,
      username: 'de9to1x4teat',
      socketId: '7TNsssr16nigp9DVAAX2',
      currentDecision: null,
      currentBet: 10,
      hand: [
        {suit: 'HEART', rank: 5},
        {suit: 'HEART', rank: 9},
      ],
      handLength: 2,
      order: 3,
      role: 'BUTTON',
      isFolded: true,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/f49e2cbc-7f55-4843-930c-6755ff0fe144.png',
      remainingMoney: 1.88,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 2,
      username: 'gainz2016',
      socketId: 'QSFc2l98iDcjoZc9AASa',
      currentDecision: null,
      currentBet: 0,
      hand: null,
      handLength: 2,
      order: 0,
      role: 'SMALL_BLIND',
      isFolded: true,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/f49e2cbc-7f55-4843-930c-6755ff0fe144.png',
      remainingMoney: 12.7,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 3,
      username: 'gainz2016',
      socketId: 'QSFc2l98iDcjoZc9AASa',
      currentDecision: null,
      currentBet: 0,
      hand: null,
      handLength: 2,
      order: 0,
      role: 'SMALL_BLIND',
      isFolded: true,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/f49e2cbc-7f55-4843-930c-6755ff0fe144.png',
      remainingMoney: 12.7,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 4,
      username: 'gainz2016',
      socketId: 'QSFc2l98iDcjoZc9AASa',
      currentDecision: null,
      currentBet: 0,
      hand: null,
      handLength: 2,
      order: 0,
      role: 'SMALL_BLIND',
      isFolded: true,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/f49e2cbc-7f55-4843-930c-6755ff0fe144.png',
      remainingMoney: 12.7,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 5,
      username: 'VirtuallyJon',
      socketId: 'gutwIoBCyxto0HtqAAUn',
      currentDecision: null,
      currentBet: 0,
      hand: null,
      handLength: 2,
      order: 1,
      role: 'BIG_BLIND',
      isFolded: true,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/ab5d43bb-b349-430c-8e6e-1c64b43b67f7.png',
      remainingMoney: 7.16,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
  ],
  communityCards: [
    {
      suit: 'CLUB',
      rank: 2,
    },
    {
      suit: 'CLUB',
      rank: 3,
    },
    {
      suit: 'CLUB',
      rank: 4,
    },
  ],
  playerInAction: 1,
  prevPot: 0.17,
  minBet: 0.06,
  callAmount: 0.06,
  currentPlayerActionExpireAt: '2024-09-16T08:47:23.852Z',
  currentPlayerActionTotalDuration: 30,
  isNewStreet: false,
  isPlayCardFlipAnimation: false,
  isCleanTable: true,
  soundEffect: null,
  currentPlayerTimeBankExpiredAt: null,
  currentPlayerTimeBankEnable: false,
  buttonPosition: 1,
  isInsuranceTriggered: false,
  isResultShown: true,
};

export const getMockTableInfo = ({
  gameType,
  hasResult,
}: {
  gameType: GameType;
  hasResult: boolean;
}) => {
  const tableInfo = cloneDeep(mockTableInfo);
  tableInfo.isResultShown = hasResult;
  tableInfo.players = tableInfo.players.map((player, index) => {
    if (!player) {
      return player;
    }
    return getMockPlayer({
      index,
      gameType,
      hasResult,
    });
  });

  return tableInfo;
};

export const mockPlayer = (index: number): PlayerComponent => {
  return {
    id: index,
    icon: null,
    username: 'ben',
    socketId: index.toString(),
    role: index !== 7 ? 'BUTTON' : null,
    order: index,
    gameMode: 'REGULAR',
    roomCode: null,
    outCards: Array(12)
      .fill(null)
      .map(() => ({suit: 'SPADE', rank: 10})) as GameLogicInterface.CardObj[],

    remainingMoney: [100, 1000, 10000][Math.floor(Math.random() * 3)],
    hand: null,
    handLength: 2,
    isFolded: false,
    isActive: true,
    isDisconnected: false,
    isSatOut: false,
    isSitOutNextHand: false,
    currentDecision: 'BET', // bet call, including small and big blind
    currentBet: 102,
    availableActions: ['BET', 'CHECK', 'FOLD'],
    isAllIn: false,
    isAllInMode: false,
    // useImperative methods

    actionTime: 10,
    isResultShowing: true,
    isTimerHidden: false,
    disconnectedAt: null,
    forceKickAt: null,

    isWaitingForBlinds: false,
    needWaitForBlinds: false,
  };
};

export const mockPlayersOmaha = (index: number): PlayerComponent => {
  const clone = cloneDeep(mockPlayer(index));
  clone.gameMode = 'OMAHA';
  clone.hand = [
    {
      suit: 'HEART',
      rank: 5,
    },
    {
      suit: 'HEART',
      rank: 9,
    },
    {
      suit: 'SPADE',
      rank: 9,
    },
    {
      suit: 'CLUB',
      rank: 9,
    },
  ];
  return clone;
};

export const mockResult: any = {
  result: [
    {
      cardValues: 14,
      selectedCards: [
        {rank: 2, suit: 'CLUB'},
        {rank: 3, suit: 'CLUB'},
        {
          rank: 9,
          suit: 'HEART',
        },
        {
          rank: 4,
          suit: 'SPADE',
        },
        {
          rank: 6,
          suit: 'DIAMOND',
        },
      ],
      winAmountForPlayer: 10,
      potAmount: 100,
      combinationName: 'PAIR',
      potSequence: 0,
      potWinnerIds: [0, 1],
      playerContribution: null,
      selectedCardsByPlayerId: {
        '0': [
          {rank: 2, suit: 'CLUB'},
          {rank: 3, suit: 'CLUB'},
          {
            rank: 9,
            suit: 'HEART',
          },
          {
            rank: 5,
            suit: 'HEART',
          },
          {
            rank: 9,
            suit: 'CLUB',
          },
        ],
        '1': [
          {rank: 2, suit: 'CLUB'},
          {rank: 3, suit: 'CLUB'},
          {
            rank: 9,
            suit: 'HEART',
          },
          {
            rank: 5,
            suit: 'HEART',
          },
          {
            rank: 9,
            suit: 'CLUB',
          },
        ],
        '2': [
          {rank: 2, suit: 'CLUB'},
          {rank: 3, suit: 'CLUB'},
          {
            rank: 9,
            suit: 'HEART',
          },
          {
            rank: 5,
            suit: 'HEART',
          },
          {
            rank: 9,
            suit: 'CLUB',
          },
        ],
        '3': [
          {rank: 2, suit: 'CLUB'},
          {rank: 3, suit: 'CLUB'},
          {
            rank: 9,
            suit: 'HEART',
          },
          {
            rank: 5,
            suit: 'HEART',
          },
          {
            rank: 9,
            suit: 'CLUB',
          },
        ],
        '4': [
          {rank: 2, suit: 'CLUB'},
          {rank: 3, suit: 'CLUB'},
          {
            rank: 9,
            suit: 'HEART',
          },
          {
            rank: 5,
            suit: 'HEART',
          },
          {
            rank: 9,
            suit: 'CLUB',
          },
        ],
        '5': [
          {rank: 2, suit: 'CLUB'},
          {rank: 3, suit: 'CLUB'},
          {
            rank: 9,
            suit: 'HEART',
          },
          {
            rank: 5,
            suit: 'HEART',
          },
          {
            rank: 9,
            suit: 'CLUB',
          },
        ],
      },
    },
    {
      cardValues: 2,
      selectedCards: [
        {rank: 2, suit: 'CLUB'},
        {rank: 14, suit: 'DIAMOND'},
        {
          rank: 13,
          suit: 'HEART',
        },
        {
          rank: 4,
          suit: 'CLUB',
        },
        {
          rank: 6,
          suit: 'DIAMOND',
        },
      ],
      winAmountForPlayer: 25,
      potAmount: 50,
      combinationName: 'FLUSH',
      potSequence: 1,
      potWinnerIds: [1],
    },
  ],
  players: mockTableInfo.players,
};

export const getMockResult = ({gameType}: {gameType: GameType}) => {
  const result = cloneDeep(mockResult);
  result.players = getMockTableInfo({gameType, hasResult: true}).players.map((player, index) => {
    if (!player) {
      return player;
    }
    return getMockPlayer({
      index,
      gameType,
      hasResult: true,
    });
  });
  return result;
};

export const mockCard = {
  suit: SUIT.CLUB,
  rank: 2,
};

const getMockCardWithValue = (value: number, suit: SUIT = SUIT.CLUB) => ({
  suit,
  rank: value,
});

export const mockCommunityCard: Array<PokerComponent> = [];
for (let iii = 2; iii < 7; iii += 1) {
  mockCommunityCard.push(getMockCardWithValue(iii));
}

export const mockRoomInfo = {
  small_blind: 4,
  big_blind: 9,
  game_mode: 'REGULAR',
};

export const mockInsuranceInfo = {
  isTriggered: true,
  isForced: false,
  outs: [
    {
      suit: 'SPADE',
      rank: 10,
    },
    {
      suit: 'HEART',
      rank: 10,
    },
    {
      suit: 'DIAMOND',
      rank: 10,
    },
    {
      suit: 'SPADE',
      rank: 10,
    },
    {
      suit: 'HEART',
      rank: 10,
    },
    {
      suit: 'SPADE',
      rank: 10,
    },
    {
      suit: 'HEART',
      rank: 10,
    },
    {
      suit: 'DIAMOND',
      rank: 10,
    },
    {
      suit: 'SPADE',
      rank: 10,
    },
    {
      suit: 'HEART',
      rank: 10,
    },
    {
      suit: 'SPADE',
      rank: 10,
    },
    {
      suit: 'HEART',
      rank: 10,
    },
  ] as GameLogicInterface.CardObj[],
  odds: 10,
  advantageousPlayerId: 0,
  winningPercentages: {
    '0': 85.15,
    '5': 14.85,
    // '0': 85.15,
    // '1': 85.15,
    // '2': 85.15,
    // '3': 85.15,
    // '4': 85.15,
    // '5': 85.15,

    // '0': 14.85,
    // '1': 14.85,
    // '2': 14.85,
    // '3': 14.85,
    // '4': 14.85,
    // '5': 14.85,
  },
  minPremium: 0,
  maxPremium: 24,
};

export const mockGameListPreviewInfo = {
  roomCode: '471X9',
  gameId: 5125894,
  timestamp: 1736837705510,
  currentPot: 0.1,
  players: [
    {
      id: 3797,
      username: 'ireneodelpino',
      socketId: 'I6wRHMNnzw7ggCjVAAAW',
      currentDecision: 'BET',
      currentBet: 10,
      hand: null,
      handLength: 2,
      order: 2,
      role: 'BUTTON',
      isFolded: true,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/49c2d69f-643e-4b27-bd13-e58203bebf12.png',
      remainingMoney: 4.49,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 3797,
      username: 'ireneodelpino',
      socketId: 'I6wRHMNnzw7ggCjVAAAW',
      currentDecision: 'FOLD',
      currentBet: 0,
      hand: null,
      handLength: 2,
      order: 2,
      role: 'BUTTON',
      isFolded: true,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/49c2d69f-643e-4b27-bd13-e58203bebf12.png',
      remainingMoney: 4.49,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 3828,
      username: '27278495959483',
      socketId: 'uKAxS9VPVCB-pFChAAAX',
      currentDecision: 'RAISE',
      currentBet: 0.08,
      hand: null,
      handLength: 2,
      order: 0,
      role: 'SMALL_BLIND',
      isFolded: false,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/4b2429d4-9abb-44f5-bbe6-93487e6f83c9.png',
      remainingMoney: 7.09,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 3735,
      username: 'cheches_cmu',
      socketId: 'IxxkoKrWr7qgp-soAAAp',
      currentDecision: 'BB',
      currentBet: 0.02,
      hand: null,
      handLength: 2,
      order: 1,
      role: 'BIG_BLIND',
      isFolded: false,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/49c2d69f-643e-4b27-bd13-e58203bebf12.png',
      remainingMoney: 20.72,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 3735,
      username: 'cheches_cmu',
      socketId: 'IxxkoKrWr7qgp-soAAAp',
      currentDecision: 'CALL',
      currentBet: 0.02,
      hand: null,
      handLength: 2,
      order: 1,
      role: 'BIG_BLIND',
      isFolded: false,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/49c2d69f-643e-4b27-bd13-e58203bebf12.png',
      remainingMoney: 20.72,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
    {
      id: 3735,
      username: 'cheches_cmu',
      socketId: 'IxxkoKrWr7qgp-soAAAp',
      currentDecision: 'CHECK',
      currentBet: 0.02,
      hand: null,
      handLength: 2,
      order: 1,
      role: 'BIG_BLIND',
      isFolded: false,
      isActive: true,
      isDisconnected: false,
      isSatOut: false,
      isSitOutNextHand: false,
      availableActions: [],
      isAllIn: false,
      icon: '/upload/file/user/icon/49c2d69f-643e-4b27-bd13-e58203bebf12.png',
      remainingMoney: 20.72,
      disconnectedAt: null,
      forceKickAt: null,
      needWaitForBlinds: false,
      isWaitingForBlinds: false,
    },
  ],
  communityCards: [],
  playerInAction: 1,
  prevPot: 0,
  minBet: 0.06,
  callAmount: 0.08,
  currentPlayerActionExpireAt: '2025-01-14T06:55:35.464Z',
  currentPlayerActionTotalDuration: 30,
  isNewStreet: false,
  canStreetFinish: false,
  isPlayCardFlipAnimation: false,
  isWaitingForNextPlayerAction: false,
  isCleanTable: false,
  soundEffect: null,
  currentPlayerTimeBankExpiredAt: null,
  currentPlayerTimeBankEnable: false,
  buttonPosition: 1,
  isInsuranceTriggered: false,
  isResultShown: false,
};
